__turbopack_context__.v({
  "bodyText": "LeasingPage-module__S5JCua__bodyText",
  "button": "LeasingPage-module__S5JCua__button",
  "ctaContainer": "LeasingPage-module__S5JCua__ctaContainer",
  "ctasWrapper": "LeasingPage-module__S5JCua__ctasWrapper",
  "footer": "LeasingPage-module__S5JCua__footer",
  "fullWidth": "LeasingPage-module__S5JCua__fullWidth",
  "leasingGuide": "LeasingPage-module__S5JCua__leasingGuide",
  "leasingGuideWrapper": "LeasingPage-module__S5JCua__leasingGuideWrapper",
  "offerGuide": "LeasingPage-module__S5JCua__offerGuide",
  "skeletonHero": "LeasingPage-module__S5JCua__skeletonHero",
});
